import WMTS, {optionsFromCapabilities} from 'ol/source/WMTS';
import {WMTSCapabilities, WMSCapabilities} from 'ol/format';
import XYZ from 'ol/source/XYZ';
import TileWMS from 'ol/source/TileWMS';

import {getCapabilitiesByName} from '@/api/visor/mapBase/mapBase.api';

const parserWMTS = new WMTSCapabilities();
const parserWMS = new WMSCapabilities();

async function getLayerFromCapabilitiesWMTS(props) {
  const response = await getOptionsFromCapabilities(props);
  if (response) {
    return new WMTS({
      ...response,
      crossOrigin: 'anonymous',
    });
  }
  return null;
}

async function getLayerFromCapabilitiesWMS(props) {
  const response = await getOptionsFromCapabilities(props);
  if (response) {
    let {url, params} = response;
    if (props.params) {
      params = {
        ...params,
        ...props.params,
      };
    }

    params.SRS = 'EPSG:25830';

    if (props.matrixSet) {
      params.SRS = props.matrixSet;
    }

    const paramsWMS = {
      url,
      params,
      crossOrigin: props?.crossOrigin,
    };

    return new TileWMS(paramsWMS);
  }
}

function getLayerFromTMS(obj) {
  let imgFormat = 'png';
  if (obj.params?.FORMAT === 'image/jpeg') {
    imgFormat = 'jpeg';
  }
  return new XYZ({
    url: `${obj.url}/{z}/{x}/{-y}.${imgFormat}`,
    crossOrigin: 'anonymous',
  });
}

function getLayerFromXYZ(obj) {
  let imgFormat = 'png';
  if (obj.params?.FORMAT === 'image/jpeg') {
    imgFormat = 'jpeg';
  }
  return new XYZ({
    url: `${obj.url}/{z}/{x}/{-y}.${imgFormat}`,
    crossOrigin: 'anonymous',
  });
}

/**
 * Request to get the capabilities
 *
 * @param {String} url
 *
 * @return {XML}
 */
async function getCapabilitiesByUrl(url) {
  const capStorage = localStorage.getItem('capabilities');
  if (!capStorage) {
    const promiseCapabilities = new Promise((resolve, reject) => {
      fetch(url?.toLowerCase())
        .then((response) => response.text())
        .then((capabilities) => {
          localStorage.setItem('capabilities', capabilities);
          resolve(capabilities);
        })
        .catch((error) => {
          reject(error);
        });
    });
    const capabilities = await promiseCapabilities;
    if (capabilities) {
      return capabilities;
    }
  } else {
    return capStorage;
  }
}

/**
 * Function to get the capabilities of layer
 *
 * @param {Object} obj
 *  {
 *    url: {String}
 *    layer: {String}
 *    format: {String}
 *    matrixSet: {String}
 *  }
 *
 * @return {Object}
 */
async function getOptionsFromCapabilities(
  {url, layer, format, matrixSet = 'EPSG:25830'},
) {
  let capabilities = null;
  if (!layer.includes(':')) {
    capabilities = await getCapabilitiesByName(layer);
  }
  // console.log(layer);
  if (!capabilities) {
    capabilities = await getCapabilitiesByUrl(url);
  }

  if (capabilities) {
    if (format.toLowerCase() === 'wmts') {
      const result = parserWMTS.read(capabilities);
      const options = optionsFromCapabilities(result, {
        layer,
        matrixSet,
      });
      return options;
    } else if (format.toLowerCase() === 'wms') {
      const result = parserWMS.read(capabilities);

      return {
        url: result.Capability?.Request.GetMap.DCPType[0].HTTP.Get.OnlineResource,
        params: {
          LAYERS: layer,
        },
      };
    }
  }

  return null;
}

export default async (obj) => {
  const format = obj?.format?.toLowerCase();
  if (format === 'wmts') {
    return await getLayerFromCapabilitiesWMTS(obj);
  }
  if (format === 'wms') {
    return await getLayerFromCapabilitiesWMS(obj);
  }
  if (format === 'tms') {
    return getLayerFromTMS(obj);
  }
  if (format === 'xyz') {
    return getLayerFromXYZ(obj);
  }
};
